import { z } from 'zod';

export const emailLoginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email'),
});
export type EmailLoginValues = z.infer<typeof emailLoginSchema>;
